<!--
 * @Author: 姚林刚
 * @Date: 2023-04-28 13:22:58
 * @LastEditors: 姚林刚
 * @LastEditTime: 2023-06-21 11:05:40
 * @Description: 作业类型筛选组件
-->
<template>
  <div class="jobtype_select" :class="isShowJobType?'':'rotate'">
    <div class="jobtype_switch" :class="{'active':isShowJobType, 'left_fold_open':getLeftFold,'left_fold_close':!getLeftFold}" @click="isShowJobType=!isShowJobType"></div>
    <div class="select_left" :class="{'move':total>=12, 'more_than_18':total>18, 'left_fold_close':!getLeftFold}">
      <div class="item"
        @click="selectHandler(v,i)"
        v-for="(v,i) in leftJobTypeList" :key="i"
        :class="v.jobTypeCode == value?'active':''">
          <img class="icon" :src="v.jobTypeCode == value ? v.iconActive : v.icon" alt="">
          <div class="hint-text"><span>{{ v.jobTypeName || '--' }}</span></div>
      </div>
    </div>
    <div class="select_right" :class="{'move':total>=12, 'more_than_18':total>18, 'right_fold_close':!getRightFold}">
      <div class="item"
        @click="selectHandler(v,i)"
        v-for="(v,i) in rightJobTypeList" :key="i"
        :class="v.jobTypeCode == value?'active':''">
          <img class="icon" :src="v.jobTypeCode == value ? v.iconActive : v.icon" alt="">
          <div class="hint-text"><span>{{ v.jobTypeName || '--' }}</span></div>
      </div>
    </div>
    <div class="page_fold_panel">
      <div class="left_fold" :class="{'move':total>=12, 'more_than_18':total>18, 'left_fold_open':getLeftFold,'left_fold_close':!getLeftFold}">
        <div v-if="getLeftFold" @click="$store.dispatch('setLeftFold', false)">
          <img class="open" src="../../assets/images/common/img_sf_l.png" alt="">
        </div>
        <div v-else @click="$store.dispatch('setLeftFold', true)">
          <img class="close" src="../../assets/images/common/img_zk_l.png" alt="">
        </div>
      </div>
      <div class="right_fold" :class="{'move':total>=12, 'more_than_18':total>18, 'right_fold_open':getRightFold,'right_fold_close':!getRightFold}">
        <div v-if="getRightFold" @click="$store.dispatch('setRightFold', false)">
          <img class="open" v-if="getRightFold" src="../../assets/images/common/img_sf_r.png" alt="">
        </div>
        <div v-else @click="$store.dispatch('setRightFold', true)">
          <img class="close" src="../../assets/images/common/img_zk_r.png" alt="">
        </div>
      </div>
    </div>
  </div> 
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: {
      options: {
        type: Array
      },
      value: {
        type: (Number,String),
        default: null
      }
    },
    data() {
      return {
        // 左侧作业类型数据
        leftJobTypeList: [],
        // 右侧作业类型数据
        rightJobTypeList: [],
        // 显示隐藏
        isShowJobType: true,
        total: 0
      }
    },
    computed: {
      ...mapGetters(["getLeftFold", "getRightFold"]),
    },
    watch: {
      options: {
        handler(jobTypeArr) {
          this.leftJobTypeList = [];
          this.rightJobTypeList = [];
          this.total = jobTypeArr.length;
          jobTypeArr.map((v,i) => {
            // 作业类型分左右两个数组
            if(this.total<=12) {
              if((i>=0 && i<3) || (i<9 && i>=6)) this.leftJobTypeList.push(v); // 0-3个、6-9个不分组到右边
              else if((i<6 && i>=3) || (i<12 && i>=9)) this.rightJobTypeList.push(v);
              else if(i%2 === 0 ) this.leftJobTypeList.push(v);
              else this.rightJobTypeList.push(v);
            } else if(this.total>18) {
              if((i>=0 && i<5) || (i<16 && i>=10)) this.leftJobTypeList.push(v);
              else if((i<10 && i>=5) || (i<22 && i>=16)) this.rightJobTypeList.push(v);
              else if(i%2 === 0 ) this.leftJobTypeList.push(v);
              else this.rightJobTypeList.push(v);
            } else {
              if((i>=0 && i<4) || (i<13 && i>=8)) this.leftJobTypeList.push(v); // 0-3个、6-9个不分组到右边
              else if((i<7 && i>=4) || (i<17 && i>=13)) this.rightJobTypeList.push(v);
              else if(i%2 === 0 ) this.leftJobTypeList.push(v);
              else this.rightJobTypeList.push(v);
            }
            // 
          });
          if(!jobTypeArr.some(v=>{return this.value == v.jobTypeCode}) || !this.value) this.resetSelect();
        }
      }
    },
    methods: {
      /** 重置选择 */
      resetSelect() {
        this.$emit('input',undefined);
        this.$emit('change',{jobTypeCode:undefined});
      },
      /** 类型选择 */
      selectHandler(e) {
        this.$emit('input',e.jobTypeCode);
        this.$emit('change',e);
      }
    },
  }
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.jobtype_select {
  .jobtype_switch {
    position: absolute;
    width: vw(57);
    height: vw(40);
    left: vw(557);
    top: vh(28.1);
    background: url('../../assets/images/jobIcon/menu_icon_show.png') no-repeat;
    background-size: 100% 100%;
    z-index: 1000;
    transition: all 350ms;
    cursor: pointer;
    &.active {
      background: url('../../assets/images/jobIcon/menu_icon_hide.png') no-repeat;
      background-size: 100% 100%;
      transition: all 350ms;
    }
    &.left_fold_close {
      left: -100%;
      transition: all 300ms;
    }
  }
  .select_left,
  .select_right {
    position: absolute;
    top: vh(140);
    z-index: 9;
    width: vw(80);
    height: 100%;
    left: vw(398);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 300ms;
    // background: rgba(240, 22, 25,0.5);
    .item {
      width: vw(56);
      height: vw(63);
      display: flex;
      align-items: center;
      justify-content: center;
      background: url('../../assets/images/jobIcon/btn_type.png') no-repeat;
      background-size: 100% 100%;
      position: relative;
      font-size: fontSize(14);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFECC6;
      transition: all 200ms;
      cursor: pointer;
      .hint-text {
        position: absolute;
        left: vw(32);
        width: vw(0);
        height: vw(37);
        background: url('../../assets/images/jobIcon/btn_menuname_bg.png') no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: -1;
        transition: width 450ms, opacity 1050ms;
        color: rgba(255,255,255,0);
        overflow: hidden;
        z-index: -1;
        opacity: 0;
      }
      &.active {
        background: url('../../assets/images/jobIcon/btn_type_c.png') no-repeat;
        background-size: 100% 100%;
        .hint-text {
          position: absolute;
          width: vw(188);
          transition: width 450ms, opacity 1050ms;
          color: #FFECC6;
          opacity: 1;
          overflow: hidden;
          z-index: -1;
        }
      }
      .icon {
        width: 100%;
        height: 100%;
      }
    }
  }
  .select_right {
    left: auto;
    right: vw(398);
    .item {
      .hint-text {
        left: auto;
        right: vw(32);
        transform: rotateY(180deg);
        span {
          transform: rotateY(180deg);
        }
      }
    }
  }
  &.rotate {
    .select_left,
    .select_right {
      .item {
        // transform: rotateY(-90deg);
        // transform: translateY(150vh);
        // opacity: 0;
        width: 0;
        height: 0;
        overflow: hidden;
        transition: all 200ms;
      }
    }
  }
  .select_left {
    .item {
      &:nth-of-type(1) {
        margin-right: vh(2);
        margin-bottom: vh(24);
      }
      &:nth-of-type(2) {
        margin-right: vh(16);
        margin-bottom: vh(24);
      }
      &:nth-of-type(3) {
        margin-right: vh(32);
        margin-bottom: vh(24);
      }
      &:nth-of-type(4) {
        margin-right: vh(66);
        margin-top: vh(146);
        margin-bottom: vh(24);
      }
      &:nth-of-type(5) {
        margin-right: vh(78);
        margin-bottom: vh(24);
      }
      &:nth-of-type(6) {
        margin-right: vh(92);
        margin-bottom: vh(24);
      }
    }
    &.move {
      top: vh(106);.item {
        &:nth-of-type(1) {
          margin-right: vh(0);
          margin-bottom: vh(16);
        }
        &:nth-of-type(2) {
          margin-right: vh(14);
          margin-bottom: vh(16);
        }
        &:nth-of-type(3) {
          margin-right: vh(24);
          margin-bottom: vh(16);
        }
        &:nth-of-type(4) {
          margin-right: vh(36);
          margin-top: vh(0);
          margin-bottom: vh(16);
        }
        &:nth-of-type(5) {
          margin-right: vh(66);
          margin-top: vh(120);
          margin-bottom: vh(16);
        }
        &:nth-of-type(6) {
          margin-right: vh(80);
          margin-bottom: vh(16);
        }
        &:nth-of-type(7) {
          margin-right: vh(92);
          margin-bottom: vh(16);
        }
        &:nth-of-type(8) {
          margin-right: vh(66);
          margin-bottom: vh(16);
        }
        &:nth-of-type(9) {
          margin-right: vh(-12);
          margin-bottom: vh(16);
        }
      }
    }
    &.move.more_than_18 {
      top: vh(80);
      .item {
        &:nth-of-type(1) {
          margin-right: vh(-20);
          margin-bottom: vh(9);
        }
        &:nth-of-type(2) {
          margin-right: vh(8);
          margin-bottom: vh(9);
        }
        &:nth-of-type(3) {
          margin-right: vh(20);
          margin-bottom: vh(9);
        }
        &:nth-of-type(4) {
          margin-right: vh(28);
          margin-top: vh(0);
          margin-bottom: vh(9);
        }
        &:nth-of-type(5) {
          margin-right: vh(40);
          margin-top: vh(0);
          margin-bottom: vh(9);
        }
        &:nth-of-type(6) {
          margin-right: vh(66);
          margin-top: vh(84);
          margin-bottom: vh(7);
        }
        &:nth-of-type(7) {
          margin-right: vh(76);
          margin-bottom: vh(7);
        }
        &:nth-of-type(8) {
          margin-right: vh(88);
          margin-bottom: vh(7);
        }
        &:nth-of-type(9) {
          margin-right: vh(84);
          margin-bottom: vh(7);
        }
        &:nth-of-type(10) {
          margin-right: vh(14);
          margin-top: vh(-4);
          margin-bottom: vh(4);
        }
        &:nth-of-type(11) {
          margin-right: vh(-50);
          margin-bottom: vh(7);
        }
      }
    }
  }
  .select_right {
    .item {
      &:nth-of-type(1) {
        margin-left: vh(2);
        margin-bottom: vh(24);
      }
      &:nth-of-type(2) {
        margin-left: vh(20);
        margin-bottom: vh(24);
      }
      &:nth-of-type(3) {
        margin-left: vh(32);
        margin-bottom: vh(24);
      }
      &:nth-of-type(4) {
        margin-left: vh(70);
        margin-top: vh(146);
        margin-bottom: vh(24);
      }
      &:nth-of-type(5) {
        margin-left: vh(82);
        margin-bottom: vh(24);
      }
      &:nth-of-type(6) {
        margin-left: vh(96);
        margin-bottom: vh(24);
      }
    }
    &.move {
      top: vh(106);
      .item {
        &:nth-of-type(1) {
          margin-left: vh(0);
          margin-bottom: vh(16);
        }
        &:nth-of-type(2) {
          margin-left: vh(14);
          margin-bottom: vh(16);
        }
        &:nth-of-type(3) {
          margin-left: vh(26);
          margin-bottom: vh(16);
        }
        &:nth-of-type(4) {
          margin-left: vh(38);
          margin-top: vh(0);
          margin-bottom: vh(16);
        }
        &:nth-of-type(5) {
          margin-left: vh(68);
          margin-top: vh(120);
          margin-bottom: vh(16);
        }
        &:nth-of-type(6) {
          margin-left: vh(82);
          margin-bottom: vh(16);
        }
        &:nth-of-type(7) {
          margin-left: vh(94);
          margin-bottom: vh(16);
        }
        &:nth-of-type(8) {
          margin-left: vh(64);
          margin-bottom: vh(16);
        }
        &:nth-of-type(9) {
          margin-left: vh(-16);
          margin-bottom: vh(16);
        }
      }
    }
    &.move.more_than_18 {
      top: vh(80);
      .item {
        &:nth-of-type(1) {
          margin-left: vh(-18);
          margin-bottom: vh(9);
        }
        &:nth-of-type(2) {
          margin-left: vh(4);
          margin-bottom: vh(9);
        }
        &:nth-of-type(3) {
          margin-left: vh(16);
          margin-bottom: vh(9);
        }
        &:nth-of-type(4) {
          margin-left: vh(28);
          margin-top: vh(0);
          margin-bottom: vh(9);
        }
        &:nth-of-type(5) {
          margin-left: vh(40);
          margin-top: vh(0);
          margin-bottom: vh(9);
        }
        &:nth-of-type(6) {
          margin-left: vh(64);
          margin-top: vh(84);
          margin-bottom: vh(7);
        }
        &:nth-of-type(7) {
          margin-left: vh(76);
          margin-bottom: vh(7);
        }
        &:nth-of-type(8) {
          margin-left: vh(88);
          margin-bottom: vh(7);
        }
        &:nth-of-type(9) {
          margin-left: vh(86);
          margin-bottom: vh(7);
        }
        &:nth-of-type(10) {
          margin-top: vh(-6);
          margin-left: vh(20);
          margin-bottom: vh(7);
        }
        &:nth-of-type(11) {
          margin-left: vh(-28);
          margin-bottom: vh(7);
        }
      }
    }
  }
}
.select_left {
  left: 0;
  transition: all 300ms;
  &.left_fold_close {
    left: -100%;
    transition: all 300ms;
  }
}
.select_right {
  right: 0;
  transition: all 300ms;
  &.right_fold_close {
    right: -100%;
    transition: all 300ms;
  }
}

.page_fold_panel {
  .left_fold,
  .right_fold {
    position: fixed;
    z-index: 9;
    top: vh(518);
    left: vw(403);
    cursor: pointer;
    transition: all 300ms;
    &.move {
      top: vh(534);
      left: vw(402);
      transition: all 300ms;
    }
    &.left_fold_close {
      width: vw(28);
      left: vw(0);
      transition: all 300ms;
    }
    .open {
      width: vw(42);
      height: vh(99);
    }
  }
  .right_fold {
    left: auto;
    right: vw(403);
    &.move {
      left: auto;
      top: vh(534);
      right: vw(402);
      transition: all 300ms;
    }
    &.right_fold_close {
      right: vw(0);
      transition: all 300ms;
    }
  }

}
</style>
